<div class="listAndCreateContainer">
	<mat-chip-listbox aria-label="Color selection">
		@for (element of elements; track element) {
			<mat-chip-option disabled>
				{{ getElementViewValue(element) }}
			</mat-chip-option>
		}
	</mat-chip-listbox>
	@if (showNoItems && elements?.length <= 0) {
		<div class="noItems">
			{{ noItemsText | translate }}
		</div>
	}
	@if (inEditMode && hasCreateButton) {
		<button [@zoomInOnEnter]="5" (click)="onAddItemClicked.emit()" class="createButton" mat-button color="accent" appStopPropagation>
			<i class="fad fa-edit"></i>{{ T.SHARED_EDITABLE_LIST_EDIT_TAG | translate }}
		</button>
	}
</div>
